"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var CheckCircleFill = function CheckCircleFill(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className),
    viewBox: "0 0 24 24",
    height: "20px",
    width: "20px"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12C23.992 5.376 18.624.008 12 0zm6.927 8.2l-6.845 9.289c-.336.446-.97.535-1.416.199l-.014-.011-4.888-3.908a1 1 0 011.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
  }));
};
CheckCircleFill.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
CheckCircleFill.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = CheckCircleFill;